module.exports = __webpack_public_path__ + "static/b7-8187f9c7af595f5081b1fca060a607a0.jpg";